<template>
    <form v-if="model.rollen" id="registerForm" @submit.prevent="onSubmit">
        <div v-if="hasErrors" class="server-errors">
            <h3>Es sind Fehler aufgetreten</h3>
            <p>Folgende Fehler sind aufgetreten:</p>
            <p v-for="msg in errors"><em class="error">-{{msg}}</em></p>
            <p>Bitte korrigieren Sie Ihre Eingaben und schicken Sie das Formular noch einmal ab.</p>
        </div>

        <div class="server-errors" v-if="model.berufsnachweisArt == 'Upload' && this.model.berufsnachweis == null">
            <h3>Laden sie einen Berufsnachweis hoch oder wählen sie eine andere Zustellung für Ihren Berufsnachweis</h3>
        </div>

        <div class="input-group">
            <h3>
                Zugangsdaten
            </h3>
            <div class="form input-text-single">
                <span class="input">
                    <input id="Benutzername" name="Benutzername" placeholder="Benutzername*" type="text" v-model="model.benutzername" required>
                </span>
            </div>
            <div class="form input-text-double-1">
                <span class="input">
                    <input id="Passwort" name="Passwort" placeholder="Passwort*" type="password" v-model="model.passwort" required>
                </span>
                <span class="password-strength-container">
                    <span class="password-strength"></span>
                </span>
            </div>
            <div class="form input-text-single-half">
                <span class="input">
                    <input id="PasswortWiederholung" name="PasswortWiederholung" placeholder="Passwort bestätigen*" type="password" v-model="model.passwortWiederholung" required>
                </span>
            </div>
        </div>
        <div class="input-group">
            <h3>
                Persönliche Angaben
            </h3>
            <!-- Input zweispaltig 1 -->
            <div class="form input-text-double-1">
                <span class="input">
                    <span class="select-style">
                        <select name="Anrede" id="Anrede" v-model="model.anrede" required>
                            <option value="" disabled>Anrede*</option>
                            <option v-for="s in anreden" :value="s">{{s}}</option>
                        </select>
                    </span>
                </span>
                <span class="input">
                    <span class="select-style">
                        <select id="Titel" name="Titel" v-model="model.titel">
                            <option :value="null" disabled>Titel</option>
                            <option v-for="s in titel" :value="s">{{s}}</option>
                        </select>
                    </span>
                </span>
            </div>
            <div class="form input-text-double-1">
                <span class="input">
                    <!-- <label for="Vorname">Vorname*</label> -->
                    <input id="Vorname" name="Vorname" placeholder="Vorname*" type="text" v-model="model.vorname" required />
                </span>
                <span class="input">
                    <!-- <label for="Nachname">Nachname*</label> -->
                    <input id="Nachname" name="Nachname" placeholder="Nachname*" type="text" v-model="model.nachname" required />
                </span>
            </div>
        </div>
        <div class="input-group">
            <h3>
                Berufliche Angaben
            </h3>
            <div class="form select">
                <span class="input">
                    <span class="select-style">
                        <select name="Berufsbezeichnung" id="Berufsbezeichnung" v-model="model.berufsbezeichnung" required>
                            <option value="" disabled>Ihre Berufsbezeichnung*</option>
                            <option v-for="b in rollen" :value="b">{{b}}</option>
                        </select>
                    </span>
                </span>
            </div>
            <div class="form input-text-single-half apoinputs">
                <span class="input">
                    <!-- <label for="Berufsnummer">Ärzte-Nr./IDF/BTM-Nr.(7-stellig)</label> -->
                    <input id="Berufsnummer" name="Berufsnummer" placeholder="Ärzte-Nr./IDF/BTM-Nr.(7-stellig)" type="text" v-model="model.berufsnummer">
                </span>
            </div>
            <div v-show="model.berufsbezeichnung == model.rollen.Arzt.name" class="form input-text-single">
                <span class="input">
                    <!-- <label for="Facharztgruppe">Facharztgruppe</label> -->
                    <input id="Facharztgruppe" name="Facharztgruppe" placeholder="Facharztgruppe" type="text" v-model="model.facharztgruppe">
                </span>
            </div>
            <div class="form input-text-single">
                <span class="input">
                    <!-- <label for="Institution">Institutionsname/Apothekenname/Praxis</label> -->
                    <input id="Institution" name="Institution" placeholder="Institutionsname/Apothekenname/Praxis" type="text" v-model="model.institution" required>
                </span>
            </div>
            <div class="form input-text-single kundennr">
                <span class="input">
                    <!-- <label for="KundenNummer">Ihre ALIUD-Kundennummer</label> -->
                    <input id="KundenNummer" name="KundenNummer" placeholder="Ihre ALIUD-Kundennummer" type="text" v-model="model.kundennummer">
                </span>
            </div>
            <!-- Input zweispaltig 1 -->
            <div class="form select">
                <span class="input">
                    <span class="select-style">
                        <select name="BerufsnachweisArt" id="BerufsnachweisArt" v-model="model.berufsnachweisArt">
                            <option class="zustellung" :value="null" disabled>Zustellung Ihres Berufsnachweises per</option>
                            <option v-for="s in berufsnachweise" :value="s">{{s}}</option>}
                        </select>
                    </span>
                </span>
            </div>
            <upload-berufsnachweis v-if="model.berufsnachweisArt == 'Upload'" :model="model" :sessionId:="sessionId"></upload-berufsnachweis>
        </div>
        <div class="input-group">
            <div class="input-group">
                <h3>
                    Berufliche Kontaktdaten
                </h3>
                <div class="form input-text-single">
                    <span class="input">
                        <!-- <label for="Strasse">Straße*</label> -->
                        <input id="Strasse" name="Strasse" placeholder="Straße*" type="text" v-model="model.strasse" required>
                    </span>
                </div>
                <div class="form input-text-triple-1">
                    <span class="input">
                        <!-- <label for="Land">Land</label> -->
                        <input id="Land" name="Land" placeholder="Land" :readonly="true" type="text" v-model="model.land">
                    </span>
                    <span class="input">
                        <!-- <label for="Plz">PLZ*</label> -->
                        <input id="Plz" name="Plz" placeholder="PLZ*" type="text" v-model="model.plz" required>
                    </span>
                    <span class="input">
                        <!-- <label for="Ort">Ort*</label> -->
                        <input id="Ort" name="Ort" placeholder="Ort*" type="text" v-model="model.ort" required>
                    </span>
                </div>
                <div class="form input-text-single">
                    <span class="input">
                        <input id="EMail" name="EMail" placeholder="E-Mail-Adresse*" type="email" v-model="model.eMail" required>
                    </span>
                </div>
                <div class="form input-text-single">
                    <span class="input">
                        <input id="EMailWiederholen" name="EMailWiederholen" placeholder="E-Mail-Adresse wiederholen*" type="email" v-model="model.eMailWiederholen" required>
                    </span>
                </div>
                <div class="form input-text-double-1">
                    <span class="input">
                        <input id="Telefon" name="Telefon" placeholder="Telefon" type="text" v-model="model.telefon">
                    </span>
                    <span class="input">
                        <input id="Fax" name="Fax" placeholder="Fax" type="text" v-model="model.fax">
                    </span>
                </div>
            </div>

            <div class="input-group">
                <h3>
                    Newsletter
                </h3>
                <!-- <div class="form input-checkbox">
                <p>Bitte senden Sie mir regelmäßig folgende Newsletter:</p>
            </div> -->
                <newsletter-abos :model="model"></newsletter-abos>
                <div class="textonly">
                    <hr>
                </div>
                <div class="textonly">
                    <h3>AGB und Datenschutzbestimmung:</h3>
                </div>
                <div class="input-group">
                    <div class="form input-checkbox">
                        <p>
                            <input class="check-box" id="NewsletterAkzeptieren" name="NewsletterAkzeptieren" type="checkbox" v-model="model.agbGelesen" required>
                            Ja, ich habe die <a href="https://www.aliud.de/metaseiten/datenschutz" target="_blank"> Informationen zum Datenschutz, </a>
                            <a href="#" class="popover privacy"> Hinweise zur Datenverwendung</a> und die<br>
                            <a href="https://www.aliud.de/metaseiten/agb" target="_blank"> Allgemeinen Geschäftsbedingungen</a> gelesen und bin damit einverstanden.*
                        </p>
                    </div>
                </div>
            </div>

            <div class="textonly">
                <hr>
            </div>
            <h3>
                Mitteilung
            </h3>
            <div class="form textarea">
                <span>
                    <textarea cols="20" id="Mitteilung" placeholder="Sie wollen uns etwas mitteilen?" v-model="model.mitteilung"></textarea>
                </span>
            </div>
            <div class="textonly legend">
                <p>*Pflichtfelder</p>
            </div>
        </div>
        <div class="form input-submit">
            <!-- <input type="submit" name="input-submit" id="input-submit" @click="onSubmit" value="Registrieren"> -->
            <input type="submit" name="input-submit" id="input-submit" value="Registrieren">
        </div>


        <div class="popoverContent privacy">
            <h3>Hinweise zur Datenverwendung: </h3>
            <p>
                Ich willige gegenüber der ALIUD PHARMA in die Verwendung meiner oben aufgeführten E-Mail-Adresse zur Zusendung von Newslettern ein. Eine Abmeldung ist jederzeit möglich. Datennutzung und -speicherung: Wir machen Sie darauf aufmerksam, dass ALIUD PHARMA Ihre Daten ausschließlich im Rahmen der gesetzlichen Bestimmungen zur Übersendung von Newslettern verwenden wird und diese hierzu auch an externe Dienstleister weitergeben kann. Für den Fall, dass Sie weitere Informationen zum Umgang mit Ihren Daten erfahren und/oder zukünftig keine Informationen zu unseren Produkten oder Veranstaltungen mehr erhalten möchten, können Sie uns dies ohne Angabe von Gründen über unten genannte Kontaktdaten mitteilen.
            </p>
        </div>
    </form>
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import axios, { AxiosError } from "axios";
    import { extractAttrs } from "../../services/extract-attrs";
    import UploadBerufsnachweis from "./UploadBerufsnachweis.vue";
    import NewsletterAbos from "./NewsletterAbos.vue";

    const RegistrierungForm = defineComponent({
        name: "RegistrierungForm",
        data() {
            return {
                viewData: Object,
                model: Object,
                sessionId: "",
                anreden: ["Frau", "Herr"],
                titel: ["Dr.", "Prof.", "Prof. Dr."],
                rollen: [] as string[],
                berufsnachweise: ["Upload", "Fax", "Post"],
                hasErrors: false,
                errors: [] as string[]
            }
        },
        props: {
            container: HTMLElement
        },
        async beforeMount() {
            var attrs = extractAttrs(this.container!);
            var session = attrs["session"];
            var params:any = {
                sessionId: session
            }

            var response = await axios.get("/umbraco/login/registrierungform/getmodel", params);
            this.model = response.data;
            const roleObj = this.model.rollen as any;
            for (const key of Object.keys(roleObj)) {
                this.rollen.push(roleObj[key].name);
            }

            this.model.anrede = this.model.anrede ?? "";
            this.model.berufsbezeichnung = this.model.berufsbezeichnung ?? "";

            this.sessionId = response.data["sessionId"];
            return false; // Erzeugt den Promise
        },
        methods: {
            onSubmit() {

                if (this.model.berufsnachweisArt == "Upload" && this.model.berufsnachweis == null) {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth' // Für sanftes Scrollen
                    });

                    return true; // Ohne den async Aufruf brauchen wir keinen Promise
                }

                var params: any = this.model;
                params["SessionId"] = this.sessionId;

                axios.post("/umbraco/login/registrierungform/sendmail", params).then((response)=>{
                    this.viewData = response.data;
                    this.sessionId = response.data.SessionId;

                    if (response.data.redirectTo) {
                        window.location.replace(response.data.redirectTo);
                    }

                    if (this.viewData.Errors && this.viewData.Errors.length > 0) {
                        this.hasErrors=true;
                        this.errors=[...this.viewData.Errors];
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth' // Für sanftes Scrollen
                        });
                    }
                }).catch((reason: AxiosError)=>{
                    const data : any = reason.response?.data;
                    const errors : registrierungErrors = data.errors;
                    const serverSideErrors = [] as string[];
                    for (const key in errors) {
                        if(errors.hasOwnProperty(key)){
                            const errorArray = errors[key as keyof typeof errors] as string[];
                            for(let i= 0; i < errorArray.length; i++) {
                                serverSideErrors.push(errorArray[i]);
                            }
                        }
                    }

                    this.hasErrors=true;
                    this.errors=[...serverSideErrors];

                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth' // Für sanftes Scrollen
                    });
                });
            }
        },
        components: {
            UploadBerufsnachweis,
            NewsletterAbos
        }
    });
    export default RegistrierungForm;

    interface registrierungErrors {
        Passwort? : string[],
        Benutzername? : string[],
        PasswortWiederholung? : string[],
        Anrede? : string[],
        Vorname? : string[],
        Nachname? : string[],
        Berufsbezeichnung?: string[],
        Institution?: string[],
        BerufsnachweisArt?: string[],
        Strasse?: string[],
        Plz?: string[],
        Ort?: string[],
        EMail?: string[],
        EMailWiederholen: string[],
        AGBGelesen: string[],
    }
</script>